(ns frontend.view.entity-viewers.modules.counterparty-diligences.model)

(def root-path [::state])

(def entities-key :entities)

(defn entities-full-path
  [containing-entity-id]
  (into root-path [containing-entity-id entities-key]))

(def create-modal-open-key :create-modal-open?)

(defn create-modal-open-full-path
  [containing-entity-id]
  (into root-path [containing-entity-id create-modal-open-key]))

(def submitting-key :submitting?)

(defn submitting-full-path
  [containing-entity-id]
  (into root-path [containing-entity-id submitting-key]))

